import { ReduxStore } from 'store/types';

import { IAuthDataProfile } from '../initialState';

function profile(state: ReduxStore): IAuthDataProfile {
  return state.auth.profile;
}

export default profile;
